// useForm.js
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useCustomForm = (initialValues = {}, validations) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isValid, ...restFormState },
    watch,
    setError,
    clearErrors,
    getValues,
    control,
    trigger,
  } = useForm({
    defaultValues: initialValues,
   ...(validations && { resolver: yupResolver(validations)}),
  });

  const onSubmit = (data) => {
    
  };

  const handleReset = () => {
    reset(initialValues);
  };

  return {
    register,
    handleSubmit,
    Controller,
    errors,
    reset,
    onSubmit,
    handleReset,
    setValue,
    watch,
    setError,
    clearErrors,
    isValid,
    useFieldArray,
    control,
    restFormState,
    getValues,
    trigger,
  };
};

export default useCustomForm;
